import { StaticConfig } from "coral-common/config";

export default function getStaticConfig() {
  // Parse and load the reporter configuration from the config element on the
  // page.
  const element = document.getElementById("config")!;
  if (!element) {
    return null;
  }

  // Parse the config from the element text, it should always be a valid JSON
  // string if the element is available. We should allow the error to bubble if
  // we are unable to parse it.
  const config: StaticConfig = JSON.parse(element.innerText);
  return config;
}
